import './style.scss';

function DeleteSchoolModal({
  mode = 'group',
  setDeleteModal,
  cancelGroup,
  deleteGroup,
  deleteSchool,
  school
}) {
  const isSchoolDelete = mode === 'school';
  const isGroupCancel = mode === 'cancelGroup';
  const title = isGroupCancel ? 'CONFIRMAR CANCELACION' : 'CONFIRMAR BORRADO';
  const schoolCode = school?.code || '-';
  const schoolLabel = school?.name || school?.address || schoolCode;
  const groupLabel = school?.groupInfo?.code || '-';
  const description = isGroupCancel
    ? `\u00bfEst\u00e1s seguro de que quieres cancelar el Grupo ${groupLabel} del Proceso Formativo ${schoolCode}?`
    : isSchoolDelete
      ? `\u00bfEst\u00e1s seguro de que quieres borrar la Entidad Aliada ${schoolLabel} permanentemente?`
      : `\u00bfEst\u00e1s seguro de que quieres borrar el Grupo ${groupLabel} del Proceso Formativo ${schoolCode} permanentemente?`;
  const warning = isGroupCancel
    ? 'Esta accion no elimina el grupo ni sus registros. El grupo quedara en estado CANCELADO y dejara de sumar en los indicadores de grupos creados.'
    : isSchoolDelete
      ? 'Esta accion eliminara la entidad aliada y los registros asociados que aun conserve. Si ese registro contiene archivos, evidencias o soportes, se perderan y no se podran recuperar.'
      : 'Esta accion eliminara el grupo y sus registros asociados. Si ese registro contiene archivos, evidencias o soportes, se perderan y no se podran recuperar.';

  function handleConfirm() {
    if (isGroupCancel) {
      cancelGroup(school?.groupInfo?.id, school?.id);
      return;
    }

    if (isSchoolDelete) {
      deleteSchool(school?.id);
      return;
    }

    deleteGroup(school?.groupInfo?.id, school?.id);
  }

  return (
    <section className='main-deleteGroup-container'>
      <p className='title'>{title}</p>
      <p className='description'>{description}</p>
      <p className='warning'>{warning}</p>
      <div className='buttons-container'>
        <button className='blue-site-button' onClick={handleConfirm} type='button'>
          {isGroupCancel
            ? 'CANCELAR GRUPO'
            : isSchoolDelete
              ? 'ELIMINAR IE'
              : 'ELIMINAR GRUPO'}
        </button>
        <button
          className='button-white-border-blue'
          onClick={() => setDeleteModal(null)}
          type='button'
        >
          {isGroupCancel ? 'VOLVER' : 'CANCELAR'}
        </button>
      </div>
    </section>
  );
}

export default DeleteSchoolModal;
